import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayout } from '@/components/layout/dashboard-layout';
import { ProjectBreadcrumb } from '@/features/estates/components/projectBreadcrumb';
import { getProject } from '@/features/projects/api/projects';

const Component = () => {
  return (
    <DashboardLayout>
      <Outlet />
    </DashboardLayout>
  );
};

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout'
)({
  component: Component,
  loader: async ({ params }) => {
    const data = await getProject(params.projectId);
    return data;
  },
  staticData: {
    breadcrumb: ProjectBreadcrumb,
  },
});
